/**
 * @desc Export table layout configuration.
 * @example
 * import { layoutConfig } from 'config/table-configs/call-list';
 */
export const layoutConfig = {
    styles: {
        borderlessSearch: false,
    },
    dimensions: {
        maxHeight: 260,
    },
    columnWidth: {
        shortDescription: 100,
        description: 720,
        
        // special columns
        _groupActions: 70, // group actions column
    },
    filterFlyoutWidths: {},
    valueColors: {},
    actionIcons: {},
};
